module.exports = __webpack_public_path__ + "img/img1.0590ea0c.svg";